import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import '../../styles/AuthForm.css';
import RightComponent from './RightSideComponent';
import logo from '../../images/logo.png';
import googleicon from '../../images/google.png';
import CustomButton from '../../components/CustomButton';
import CustomButtonWithStroke from '../../components/auth/AuthButton';
// import Typography from '../../components/Typography';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Signup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const userInfo = searchParams.get('userInfo');
    if (token && userInfo) {
      localStorage.setItem('token', token);
      localStorage.setItem('userInfo', userInfo);
      navigate('/dashboard');
    }
  }, [searchParams, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const referralCode = searchParams.get('referralCode');
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/register`, {
        ...formData,
        referralCode: referralCode || undefined,
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userInfo', JSON.stringify(response.data.user));
      navigate('/dashboard');
    } catch (error) {
      alert(error.response?.data?.message || 'Error occurred');
    }
  };

  const handleGoogleLogin = () => {
    const referralCode = searchParams.get('referralCode');
    console.log(referralCode);
    let redirectUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`;
    if (referralCode) {
      redirectUrl += `?referralCode=${referralCode}`;
    }
    window.location.href = redirectUrl;
  };

  const handleAppleLogin = () => {
    const referralCode = searchParams.get('referralCode');
    let redirectUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/apple`;
    if (referralCode) {
      redirectUrl += `?referralCode=${referralCode}`;
    }
    window.location.href = redirectUrl;
  };

  return (
    <div className="grid grid-cols-7 min-h-screen">
      <Link to="/" className='lg:left-9 left-1/2 transform -translate-x-1/2 lg:translate-x-0 ' style={{ position: 'absolute', top: '36px',}}>
        <img src={logo} alt="logo" />
      </Link>
      <div className="lg:col-span-4  col-span-7 px-4  flex justify-center items-center h-screen  bg-[#0F0F0F] text-center lg:text-left">
        <div className="mx-auto w-[464px]">
          <div className="auth-header text-center lg:text-left">Sign up</div>
          <div className="auth-desc">Please enter details to create your account</div>
          <form className="mt-2" onSubmit={handleSubmit}>
            <div className="relative z-0 w-full mb-5 group">
              <input
                type="text"
                name="name"
                placeholder="Name"
                id="name"
                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                style={{ '::placeholder': { color: 'rgba(255, 255, 255, 0.4)' } }}
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                id="email"
                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                id="phone"
                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Set password"
                id="password"
                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <div
                className="absolute right-2 top-3.5 text-gray-500 cursor-pointer"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </div>
            </div>
            <CustomButton type="submit" text="Register" />
            <div className="mt-7 flex items-center mx-auto justify-center">
              <div className="auth-another-field">
                Have an account?{' '}
                <Link to="/login" className="signup-instead cursor-pointer hover:underline">
                  Login instead
                </Link>
              </div>
            </div>
            <div className="mt-9 flex items-center mx-auto justify-center">
              <div className="auth-or-field">OR</div>
            </div>
          </form>
          <div className="mt-9">
            <CustomButtonWithStroke
              text="Sign up with Google"
              onClick={handleGoogleLogin}
              variant="google"
              icon={<img src={googleicon} alt="google" />}
            />
            <CustomButtonWithStroke
              text="Sign up with Apple"
              className="mt-[10px]"
              onClick={handleAppleLogin}
              variant="apple"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_382_270)">
                    <path
                      d="M11.6805 2.85212C12.2538 2.15915 12.6567 1.21799 12.6365 0.259346C12.6331 0.0983651 12.4862 -0.0211662 12.3271 0.00312681C11.4859 0.131658 10.5456 0.658474 9.96351 1.33991C9.42706 1.96017 8.95097 2.92408 8.98676 3.87924C8.99214 4.02317 9.11374 4.13789 9.25771 4.13381C10.1862 4.10755 11.1028 3.55159 11.6805 2.85212Z"
                      fill="#D6D6D8"
                    />
                    <path
                      d="M9.71116 3.87925C9.65565 2.39843 10.7729 0.668813 12.5863 0.1112C12.5294 0.032942 12.431 -0.0127259 12.3271 0.00312954C11.4859 0.131661 10.5456 0.658477 9.96351 1.33991C9.42706 1.96017 8.95094 2.92412 8.98676 3.87925C8.99214 4.02318 9.11375 4.13789 9.25771 4.13381C9.43775 4.12872 9.61729 4.10351 9.79402 4.06139C9.74533 4.01527 9.71383 3.9509 9.71116 3.87925Z"
                      fill="#C2C2C4"
                    />
                    <path
                      d="M16.1612 13.1029C15.5784 12.8094 13.9698 11.7968 13.9499 9.55091C13.9329 7.71248 15.1529 6.64348 15.6718 6.27023C15.795 6.1816 15.822 6.00818 15.7284 5.88875C15.2972 5.33908 14.793 4.9865 14.3087 4.75795C14.309 4.75791 14.3093 4.75784 14.3096 4.75781C14.2469 4.72817 14.1395 4.68113 14.0535 4.64728C11.6165 3.68797 10.0807 5.15838 9.15034 5.15838C8.43804 5.15838 7.33888 4.35355 6.1743 4.37552C4.64398 4.39774 3.23442 5.26575 2.44527 6.63543C1.23456 8.73686 1.63383 11.6096 2.57711 13.8484L2.57707 13.8484C2.60123 13.9057 2.63969 13.9948 2.67175 14.0668C2.67178 14.0667 2.67178 14.0667 2.67182 14.0666C2.94509 14.6803 3.25794 15.2411 3.58753 15.7178C4.34434 16.8117 5.24719 18.044 6.43347 17.9987C7.57524 17.9535 8.00689 17.2605 9.3867 17.2605C10.7656 17.2605 11.1546 17.9987 12.3619 17.9768C13.5908 17.9535 14.369 16.8605 15.1207 15.7614C15.7822 14.7956 16.1472 13.853 16.2934 13.4286C16.337 13.3021 16.2808 13.1631 16.1612 13.1029Z"
                      fill="#D6D6D8"
                    />
                    <path
                      d="M4.31238 15.7179C3.98279 15.2412 3.66994 14.6803 3.39667 14.0667C3.39667 14.0667 3.39663 14.0668 3.3966 14.0668C3.36457 13.9949 3.32642 13.9065 3.30192 13.8485L3.30196 13.8484C2.36448 11.6234 1.95508 8.74431 3.17012 6.63547C3.89894 5.37054 5.15698 4.53407 6.55053 4.39594C6.42629 4.381 6.30096 4.3732 6.17478 4.37555C4.64447 4.39777 3.23491 5.26578 2.44576 6.63547C1.23505 8.7369 1.63432 11.6096 2.5776 13.8484L2.57756 13.8485C2.60171 13.9057 2.64017 13.9949 2.67224 14.0668C2.67227 14.0668 2.67231 14.0667 2.67231 14.0667C2.94558 14.6803 3.25843 15.2412 3.58799 15.7179C4.3448 16.8118 5.24764 18.0441 6.43392 17.9988C6.55064 17.9941 6.65962 17.9825 6.76326 17.9657C5.76806 17.7639 4.98281 16.6869 4.31238 15.7179Z"
                      fill="#C2C2C4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_270">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              }
            />
          </div>
        </div>
      </div>
      <div className="lg:col-span-3 lg:flex hidden">
        <RightComponent />
      </div>
    </div>
  );
};

export default Signup;